<!-- Hero Section -->
<section class="hero-section" role="banner">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-6">
        <h1 class="hero-title">Cumple la Ley 2466</h1>
        <p class="hero-description">
          Calcula tu cuota, entiende los plazos y descarga formatos de reporte. Acompañamos certificación, ajustes razonables y reporte al MinTrabajo.
        </p>
        <div class="hero-stats">
          <div class="stat-item">
            <span class="stat-number">100%</span>
            <span class="stat-label">Cumplimiento</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">24h</span>
            <span class="stat-label">Respuesta</span>
          </div>
          <div class="stat-item">
            <span class="stat-number">0</span>
            <span class="stat-label">Multas</span>
          </div>
        </div>
        <div class="hero-actions">
          <button class="btn btn-light btn-lg px-4 me-3" (click)="calculateQuota()">
            <i class="fas fa-calculator me-2"></i>Calcular mi cuota
          </button>
          <button class="btn btn-outline-light btn-lg px-4" (click)="agendarDiagnostico()">
            <i class="fas fa-calendar-alt me-2"></i>Agendar diagnóstico legal
          </button>
        </div>
        <div class="meta-info">
          <small class="text-white-50">
            <i class="fas fa-clock me-2"></i>Última actualización: {{ lastUpdate }}
          </small>
          <br>
          <small class="text-white-50">
            <a href="https://www.alcaldiabogota.gov.co/sisjur/normas/Norma1.jsp?i=181933" 
               target="_blank" 
               rel="noopener noreferrer" 
               class="text-white-50 text-decoration-none">
              <i class="fas fa-external-link-alt me-2"></i>Ver Ley 2466 completa
            </a>
          </small>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="hero-image">
          <img src="assets/images/ley.png" alt="Ley 2466" class="img-fluid hero-ley-image">
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Main Content -->
<main>
  <!-- Calculadora de Cuota -->
  <section class="quota-calculator py-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="card border-0 shadow">
            <div class="card-header bg-primary text-white text-center">
              <h3 class="mb-0">
                <i class="fas fa-calculator me-2"></i>Calculadora de Cuota
              </h3>
            </div>
            <div class="card-body p-4">
              <form [formGroup]="quotaForm" (ngSubmit)="calculateQuota()">
                <div class="row align-items-end">
                  <div class="col-md-6">
                                         <label for="employees" class="form-label fw-bold">Número de empleados actuales internos</label>
                    <input 
                      type="number" 
                      class="form-control form-control-lg" 
                      id="employees"
                      formControlName="employees"
                      placeholder="Ej: 150"
                      min="50"
                      required
                    >
                    <div class="form-text">Mínimo 50 empleados</div>
                  </div>
                  <div class="col-md-6">
                    <button type="submit" class="btn btn-primary btn-lg w-100" [disabled]="!quotaForm.valid">
                      <i class="fas fa-calculator me-2"></i>Calcular Cuota
                    </button>
                  </div>
                </div>
              </form>

              <!-- Resultado del cálculo -->
              <div class="mt-4" *ngIf="calculatedQuota">
                <div class="alert alert-success">
                  <h4 class="alert-heading">
                    <i class="fas fa-info-circle me-2"></i>Resultado del Cálculo
                  </h4>
                  <div class="row">
                    <div class="col-md-6">
                      <p class="mb-1"><strong>Empleados:</strong> {{ calculatedQuota.employees }}</p>
                      <p class="mb-1"><strong>Personas a vincular:</strong> {{ calculatedQuota.quota }}</p>
                    </div>
                    <div class="col-md-6">
                      <p class="mb-1"><strong>Descripción:</strong> {{ calculatedQuota.description }}</p>
                      <p class="mb-0"><strong>Plazo:</strong> {{ calculatedQuota.plazo }}</p>
                    </div>
                  </div>
                  <hr>
                  <button class="btn btn-outline-success" (click)="agendarDiagnostico()">
                    <i class="fas fa-search me-2"></i>Pedir mapeo de talento
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Tabla de Obligaciones -->
  <section class="obligaciones-section py-5 bg-light">
    <div class="container">
      <h2 class="text-center mb-5">Obligaciones por Tamaño de Empresa</h2>
      <div class="table-responsive">
        <table class="table table-striped table-hover">
          <caption class="text-center fw-bold">Cuotas de contratación según la Ley 2466</caption>
          <thead class="table-dark">
            <tr>
              <th scope="col">Rango de Empleados</th>
              <th scope="col">Cuota Mínima</th>
              <th scope="col">Plazo de Aplicación</th>
              <th scope="col">Documentación Requerida</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let obligacion of obligaciones">
              <td><strong>{{ obligacion.rango }}</strong></td>
              <td>{{ obligacion.cuota }}</td>
              <td>{{ obligacion.plazo }}</td>
              <td>{{ obligacion.documentacion }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="text-center mt-4">
        <small class="text-muted">
          <i class="fas fa-info-circle me-2"></i>
          Nota: El primer año es optativo, desde el segundo año es obligatorio
        </small>
      </div>
    </div>
  </section>

  <!-- FAQ Legal -->
  <section class="faq-section py-5">
    <div class="container">
      <h2 class="text-center mb-5">Preguntas Frecuentes</h2>
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="accordion" id="faqAccordion">
            <div class="accordion-item border-0 shadow-sm mb-3" *ngFor="let faq of faqLegal; let i = index">
              <h2 class="accordion-header" id="faq-{{ i }}">
                <button 
                  class="accordion-button" 
                  [class.collapsed]="!faq.expanded"
                  type="button" 
                  (click)="toggleFaq(i)"
                  [attr.aria-expanded]="faq.expanded"
                  [attr.aria-controls]="'faq-content-' + i"
                >
                  {{ faq.pregunta }}
                </button>
              </h2>
              <div 
                id="faq-content-{{ i }}" 
                class="accordion-collapse" 
                [class.show]="faq.expanded"
                [attr.aria-labelledby]="'faq-' + i"
              >
                <div class="accordion-body">
                  {{ faq.respuesta }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Recursos Descargables -->
  <section class="recursos-section py-5 bg-light">
    <div class="container">
      <h2 class="text-center mb-5">Recursos para el Cumplimiento</h2>
      <div class="row">
        <div class="col-lg-3 col-md-6 mb-4" *ngFor="let recurso of recursosDescargables">
          <div class="card h-100 border-0 shadow-sm">
            <div class="card-body text-center">
              <i [class]="recurso.icono + ' fa-3x text-primary mb-3'"></i>
              <h5 class="card-title">{{ recurso.titulo }}</h5>
              <p class="card-text">{{ recurso.descripcion }}</p>
              <div class="d-flex justify-content-between align-items-center">
                <span class="badge bg-secondary">{{ recurso.formato }}</span>
                <button class="btn btn-outline-primary btn-sm" (click)="downloadResource(recurso)">
                  <i class="fas fa-download me-2"></i>Descargar
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Alert Importante -->
  <section class="alert-section py-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="alert alert-warning border-0 shadow" role="status">
            <div class="d-flex align-items-start">
              <i class="fas fa-exclamation-triangle fa-2x text-warning me-3 mt-1"></i>
              <div>
                <h4 class="alert-heading">¡Importante!</h4>
                <p class="mb-2">
                  <strong>No existe pago sustitutivo</strong> para la Ley 2466. La obligación es vincular personas con discapacidad o evidenciar búsqueda seria.
                </p>
                <p class="mb-0">
                  <strong>"No encontrar el perfil" no exime del cumplimiento</strong> si no hay evidencia de búsqueda seria y documentada.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
